import ConfirmDialogComponent from './Component.vue'
import { createComponent } from './helper.js';

export const useConfirmDialog = () => {
    return {
        create(options, selector) {
            createComponent(ConfirmDialogComponent, options, selector);
        }
    }
}
